import toast from "react-hot-toast";
import customFetch from "../hooks/fetchWrapper";

// Create a new area
export const createArea = async (formBody) => {
  return toast.promise(
    customFetch("areas", {
      method: "POST",
      body: JSON.stringify([formBody]),
    }),
    {
      loading: "Creating area...",
      success: (data) => `${data.message}`,
      error: "Failed to create area",
    }
  );
};

// Update an existing area
export const updateArea = async (id, formBody) => {
  return toast.promise(
    customFetch(`areas/${id}`, {
      method: "PUT",
      body: JSON.stringify(formBody),
    }),
    {
      loading: "Updating area...",
      success: (data) => `${data.message}`,
      error: "Failed to update area",
    }
  );
};

// Delete an area
export const deleteArea = async (id) => {
  return toast.promise(
    customFetch(`areas/${id}`, {
      method: "DELETE",
    })
      .then((response) => {
        // Check if response is already parsed
        if (typeof response === "object" && response !== null) {
          return response;
        }

        // If it's not parsed, try to parse it
        try {
          return JSON.parse(response);
        } catch (e) {
          // If parsing fails, return the response as is
          return { status: true, message: response };
        }
      })
      .then((data) => {
        if (!data.status) {
          throw new Error(data.message || "Delete failed");
        }
        return data;
      }),
    {
      loading: "Deleting area...",
      success: (data) => data.message || "Delete successful",
      error: (err) => err.message || "Failed to delete area",
    }
  );
};

// Fetch all areas
export const getAllEmirates = async () => {
  try {
    const response = await customFetch("areas", {
      method: "GET",
    });
    return response;
  } catch (error) {
    console.error("Error fetching areas:", error);
    throw error;
  }
};
